import axios from 'axios'
import App from './App.vue'
import router from './router'
import { createApp } from 'vue'
import VueAxios from 'vue-axios'
import { createPinia } from 'pinia'
import '@/helpers/axios-interceptor'
import FontAwesome from '@/plugins/font-awesome'
import Notifications from '@kyvg/vue3-notification'

const app = createApp(App)

app.use(router)
  .use(createPinia())
  .use(FontAwesome)
  .use(Notifications)
  .use(VueAxios, axios)
  .mount('#app')

